export const fontSizes = {
  mobile: 16,
  // Probably tablet not in use, since decided to scale down
  tablet: 16,
  desktop: 18,
};

export const desktopData = {
  min: 1024,
  normal: 1920,
};

export const fallbackFontFamilies =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";

export const normalFontFamily = `Sora, ${fallbackFontFamilies}`;
// export const headerFontFamily = `Sora, ${fallbackFontFamilies}`;

export const gamePage = {
  mobileAsidePaddings: 10,
  desktopAsidePaddings: 20,
} as const;
